<div id="wrapper">
	<app-loading-screen [status]=true></app-loading-screen>
	<app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
	<div>
		<app-tab-nav 
			[visible]="false"
			(updateType)="this.type=$event" 
			(updatePostpaid)="this.postpago=$event"
			(updatePrepaid)="this.prepago=$event" 
			(updateFixed)="this.telefoniaFijo=$event"
			(updateTotalAccountList)="this.totalAccountList=$event" 
			(updateCurrentList)="this.currentList=$event"
			(updateSelectBan)="this.selectBan=$event" 
			(updateInitializeData)="this.initializeData()">
		</app-tab-nav>
	</div>
	<div class="allcont logsize">
	
		<div class="basicrow">
			<div class="container">
				<div class="basicr-line-i">
					<div class="fulltitle m-top-i f-btitle autodef">
						<span class="icon-dash-14"></span> Mi Perfil
					</div>
				</div>
			</div>
		</div>

		<div class="basicrow mbott-i">
			<div class="container">
				<div class="basicrow m-top-i mbott tab-m-bot">
					<div class="difftabs">
						<div (click)="this.changeTab(1);" [className]="this.session===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
							Información Personal
						</div>

						<div (click)="this.changeTab(2);" [className]="this.session===2 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
							Actualiza Tu Correo
						</div>

						<div (click)="this.changeTab(3);" [className]="this.session===3 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
							Cambiar Usuario y Contraseña
						</div>

						<div (click)="this.changeTab(4);" [className]="this.session===4 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
							Dirección Postal
						</div>
						<div (click)="this.changeTab(5);" [className]="this.session===5 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
							Preguntas de Seguridad
						</div>

					</div>
				</div>
				
				<div id="personalInfo" class="basicrow f-black roboto-r f-reg m-top-i m-bott"  [ngStyle]="{'display':this.session === 1 ? 'block' : 'none' }">
                    <app-company-information [name]="this.fullName" [cel]="this.celNum" [homeNum]="this.homeNumber" [email]="this.email" ></app-company-information>
				</div>
				<div id="updateEmail" class="basicrow f-black roboto-r f-reg m-top-i m-bott"  [ngStyle]="{'display':this.session === 2 ? 'block' : 'none' }">
                    <app-update-email [email]="this.email" [cel]="this.celNum" [homeNum]="this.homeNumber"></app-update-email>
				</div>
				<div id="changePassword" class="basicrow f-black roboto-r f-reg m-top-ii" [ngStyle]="{'display':this.session === 3 ? 'block' : 'none' }">
                    <app-change-password></app-change-password>
				</div>
				<div id="postalAddress" class="basicrow f-black roboto-r f-reg m-top-ii text-center" [ngStyle]="{'display':this.session === 4 ? 'block' : 'none' }">
                    <app-postal-address [AddressDet]="AddressDet" [AddressDet2]="AddressDet2" [City]="City" [Country]="Country" [State]="State" [ZipCode]="ZipCode"></app-postal-address>
				</div>
				<div id="questions" class="basicrow f-black roboto-r f-reg m-top-i m-bott text-center" [ngStyle]="{'display':this.session === 5 ? 'block' : 'none' }">
                    <app-security-questions></app-security-questions>
				</div>
			</div>
		</div>
    </div>
    <app-footer></app-footer>
</div>